(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resale-profit-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-resale-calculator]:not([data-initialized])');
    roots.forEach((root) => {
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-calculator-form]');
      const currency = root.querySelector('[data-currency]');
      const currencyTrigger = root.querySelector('[data-currency-trigger]');
      const currencyCurrent = root.querySelector('[data-currency-current]');
      const currencyOptions = root.querySelector('[data-currency-options]');
      const currencyChoices = Array.from(root.querySelectorAll('[data-currency-option]'));
      const amountInputs = root.querySelectorAll('[data-amount]');
      const feeInputs = root.querySelectorAll('[data-fee-amount]');
      const feeTypes = root.querySelectorAll('[data-fee-type]');
      const lossBadge = root.querySelector('[data-loss]');
      const prefixNodes = root.querySelectorAll('[data-currency-prefix]');
      const symbols = { EUR: '€', USD: '$', GBP: '£', RON: 'RON' };
      const closeCurrencyPicker = (returnFocus = false) => {
        currencyOptions.hidden = true;
        currencyTrigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) currencyTrigger.focus();
      };
      const openCurrencyPicker = (focusSelected = true) => {
        currencyOptions.hidden = false;
        currencyTrigger.setAttribute('aria-expanded', 'true');
        if (focusSelected) currencyChoices.find((option) => option.dataset.currencyOption === currency.value)?.focus();
      };
      const chooseCurrency = (option) => {
        currency.value = option.dataset.currencyOption;
        currency.dispatchEvent(new Event('change', { bubbles: true }));
        closeCurrencyPicker(true);
      };
      currencyTrigger.addEventListener('click', () => {
        if (currencyOptions.hidden) openCurrencyPicker();
        else closeCurrencyPicker();
      });
      currencyTrigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openCurrencyPicker();
        }
      });
      currencyOptions.addEventListener('click', (event) => {
        const option = event.target.closest('[data-currency-option]');
        if (option) chooseCurrency(option);
      });
      currencyOptions.addEventListener('keydown', (event) => {
        const currentIndex = currencyChoices.indexOf(document.activeElement);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % currencyChoices.length;
        else if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + currencyChoices.length) % currencyChoices.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = currencyChoices.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseCurrency(document.activeElement);
          return;
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeCurrencyPicker(true);
          return;
        } else if (event.key === 'Tab') {
          closeCurrencyPicker();
          return;
        } else return;
        event.preventDefault();
        currencyChoices[nextIndex].focus();
      });
      root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-currency-picker]') && !currencyOptions.hidden) closeCurrencyPicker();
      });
      const value = (name) => {
        const field = form.elements.namedItem(name);
        if (!field || field.value.trim() === '') return 0;
        const number = Number(field.value);
        return Number.isFinite(number) && number >= 0 ? number : 0;
      };
      const fee = (input, type) => {
        const amount = input.value.trim() === '' ? 0 : Number(input.value);
        if (!Number.isFinite(amount) || amount < 0) return 0;
        return type === 'percent' ? value('sale') * amount / 100 : amount;
      };
      const money = (number) => {
        if (!Number.isFinite(number)) return '—';
        const code = currency.value;
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(number));
        const sign = number < 0 ? '−' : '';
        return code === 'RON' ? `${sign}${formatted} RON` : `${sign}${symbols[code]}${formatted}`;
      };
      const set = (key, text) => { root.querySelector(`[data-result="${key}"]`).textContent = text; };
      const ratio = (numerator, denominator) => denominator === 0 ? 'N/A' : `${(numerator / denominator * 100).toFixed(1)}%`;
      const update = () => {
        const prefix = symbols[currency.value];
        const selectedCurrency = currencyChoices.find((option) => option.dataset.currencyOption === currency.value);
        if (selectedCurrency) {
          currencyCurrent.textContent = selectedCurrency.textContent;
          currencyChoices.forEach((option) => option.setAttribute('aria-selected', String(option === selectedCurrency)));
        }
        prefixNodes.forEach((node) => { node.textContent = prefix; });
        root.querySelectorAll('[data-fee-suffix]').forEach((node) => {
          const feeControl = node.closest('.resale-calculator__input-wrap').parentElement.parentElement;
          const type = feeControl.querySelector('[data-fee-type]').value;
          node.textContent = type === 'percent' ? '%' : prefix;
        });
        if (form.elements.purchase.value.trim() === '' || form.elements.sale.value.trim() === '') {
          set('profit', 'Enter purchase and sale prices');
          set('revenue', '—'); set('costs', '—'); set('margin', '—'); set('markup', '—'); set('roi', '—');
          lossBadge.hidden = true;
          root.querySelector('[data-result="profit"]').classList.remove('is-loss');
          return;
        }
        const purchase = value('purchase');
        const revenue = value('sale');
        const costs = purchase + value('inbound') + fee(feeInputs[0], feeTypes[0].value) + fee(feeInputs[1], feeTypes[1].value) + value('packaging') + value('postage') + value('other');
        const profit = revenue - costs;
        set('profit', money(profit));
        set('revenue', money(revenue)); set('costs', money(costs));
        set('margin', ratio(profit, revenue)); set('markup', ratio(profit, purchase)); set('roi', ratio(profit, costs));
        lossBadge.hidden = profit >= 0;
        root.querySelector('[data-result="profit"]').classList.toggle('is-loss', profit < 0);
      };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      currency.addEventListener('change', update);
      form.addEventListener('reset', () => {
        currency.value = 'EUR';
        window.requestAnimationFrame(update);
      });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
